import {
  LOCALSTORAGE_TOKEN,
  LOCALSTORAGE_USER_ID,
  LOCALSTORAGE_USER_IS_MANAGER,
} from "../../config";
import axios from "axios";

export function googleAuthService(idToken) {
  let config = { headers: { Authorization: `bearer ${idToken}` } };
  return axios
    .post(
      `${process.env.API_BASE_URL}${process.env.API_LOGIN}/google`,
      null,
      config
    )
    .then(resp => {
      // login successful if there's a jwt token in the response
      if (idToken) {
        // store resp details and jwt token in local storage to keep resp logged in between page refreshes
        localStorage.setItem(LOCALSTORAGE_TOKEN, idToken);
        localStorage.setItem(LOCALSTORAGE_USER_ID, resp.data.id);
        localStorage.setItem(
          LOCALSTORAGE_USER_IS_MANAGER,
          resp.data.is_manager
        );
      }

      return resp.data;
    });
}



// WEBPACK FOOTER //
// ./src/modules/login/services.js